import { render, staticRenderFns } from "./SurgeryReview.vue?vue&type=template&id=a762830c&scoped=true"
import script from "./SurgeryReview.vue?vue&type=script&lang=js"
export * from "./SurgeryReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a762830c",
  null
  
)

export default component.exports